import { useReduxSelector, useScrollTopOnChangePage } from 'services/hooks';

export const useMorePages = () => {
  const page = useReduxSelector((redux) => redux.more.page);
  useScrollTopOnChangePage(page);

  return { page };
};
